export const CDA_TAX_PERCENT = 3
